query GetLayoutSetting {
  customerSettings {
    id
    workBlockLayout
  }
  workOrderLayoutSetting {
    customWorkOrderFields {
      fieldId
      enabled
    }
    itemCategory
    itemClass
    itemCode
    itemDescription
    itemFamily
    itemType
    materialAvailabilityDate
    plannedEndDate
    plannedStartDate
    recommendedPeople
    recommendedProductionRate
    reference1
    reference2
    reference3
    reference4
    reference5
    serviceCategory
    standardPeople
    standardProductionRate
    workOrderDescription
    workOrderId
    workOrderPriority
  }
  customWorkOrderFields {
    id
    label
  }
}

mutation UpdateLayoutSetting(
  $workBlockLayout: String!
  $customWorkOrderFields: [CustomWorkOrderFieldSettingInput!]
  $itemCategory: Boolean!
  $itemClass: Boolean!
  $itemCode: Boolean!
  $itemDescription: Boolean!
  $itemFamily: Boolean!
  $itemType: Boolean!
  $materialAvailabilityDate: Boolean!
  $plannedEndDate: Boolean!
  $plannedStartDate: Boolean!
  $recommendedPeople: Boolean!
  $recommendedProductionRate: Boolean!
  $reference1: Boolean!
  $reference2: Boolean!
  $reference3: Boolean!
  $reference4: Boolean!
  $reference5: Boolean!
  $serviceCategory: Boolean!
  $standardPeople: Boolean!
  $standardProductionRate: Boolean!
  $workOrderDescription: Boolean!
  $workOrderId: Boolean!
  $workOrderPriority: Boolean!
) {
  updateCustomerSettings(workBlockLayout: $workBlockLayout) {
    customerSettings {
      workBlockLayout
    }
  }
  updateWorkOrderLayoutSetting(
    customWorkOrderFields: $customWorkOrderFields
    itemCategory: $itemCategory
    itemClass: $itemClass
    itemCode: $itemCode
    itemDescription: $itemDescription
    itemFamily: $itemFamily
    itemType: $itemType
    materialAvailabilityDate: $materialAvailabilityDate
    plannedEndDate: $plannedEndDate
    plannedStartDate: $plannedStartDate
    recommendedPeople: $recommendedPeople
    recommendedProductionRate: $recommendedProductionRate
    reference1: $reference1
    reference2: $reference2
    reference3: $reference3
    reference4: $reference4
    reference5: $reference5
    serviceCategory: $serviceCategory
    standardPeople: $standardPeople
    standardProductionRate: $standardProductionRate
    workOrderDescription: $workOrderDescription
    workOrderId: $workOrderId
    workOrderPriority: $workOrderPriority
  ) {
    workOrderLayoutSetting {
      customWorkOrderFields {
        fieldId
        enabled
      }
      itemCategory
      itemClass
      itemCode
      itemDescription
      itemFamily
      itemType
      materialAvailabilityDate
      plannedEndDate
      plannedStartDate
      recommendedPeople
      recommendedProductionRate
      reference1
      reference2
      reference3
      reference4
      reference5
      serviceCategory
      standardPeople
      standardProductionRate
      workOrderDescription
      workOrderId
      workOrderPriority
    }
  }
}
